import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { IMAGE_LANDING_PAGES_CONVERTER_TOKEN, ImageLandingPageConverter } from './image-landing-pages.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        imageLandingPagesFeature: {
          module: () => import('./image-landing-pages.module').then((m) => m.ImageLandingPagesModule),
          cmsComponents: ['image_landing_pages']
        },
      }
    }),
    {
      provide: IMAGE_LANDING_PAGES_CONVERTER_TOKEN,
      useExisting: ImageLandingPageConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        image_landing_pages: IMAGE_LANDING_PAGES_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class ImageLandingPagesFeatureModule {}
